/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Modal,
  notification,
  Select,
  Tooltip,
  Typography,
  Upload,
  Input,
  Row,
  Col,
} from 'antd';
import {
  PlusOutlined,
  CloudUploadOutlined,
  DownloadOutlined,
  ImportOutlined,
  DatabaseOutlined,
} from '@ant-design/icons';
import { Package } from 'lucide-react';
import { Button as CrcButton } from '@crc-evans/ui-components';
import SparesList from '../../components/admin/SparesOrderList';
import AddNewSpare from '../../components/admin/AddNewSpare';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  fetchsparesEuipTypeList,
  fetchsparesEuipSNList,
  fetchSapKitNoList,
  fetchSapNoList,
  updateAdminSpare,
  deleteAdminSpare,
  addAdminSpare,
  fetchSparesAdminList,
  fetchExcelSparesAdminList,
  uploadSparesExcel,
} from '../../redux/admin/sparesAdmin/action';

import ExcelJS from 'exceljs';

const { Text, Title } = Typography;
const { Option } = Select;

const Spares = (props) => {
  const {
    onGetFetchSparesAdminList,
    onGetPihEquipmentTypes,
    onAddspare,
    onDeleteAdminSpare,
    onUpdateAdminSpare,
    onFetchExcelSparesAdminList,
    onUploadSparesExcel,
    //
    sparesAdminList,
    sparesEuipType,
    ExcelSparesAdminList,
    isSparesListLoading,
    isExcelSparesAdminDataLoading,
  } = props;

  const [checkOpen, setChecksOpen] = useState(false);
  const [openPage, setOpenPage] = useState('');

  const [spareTypeForm] = Form.useForm();
  const [equipTypeSearchForm] = Form.useForm();

  const [openModal, setOpenModel] = useState(false);
  const [equipTypeListDrop, setEquipTypeListDrop] = useState([]);
  const [equipmentType, setEquipmentType] = useState('');
  const [editModelValue, setEditModelValue] = useState('');
  const [editRecord, setEditRecord] = useState('');

  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [equipTypeList, setEquipTypeList] = useState([]);
  const [currency, setCurrency] = useState('');
  const [editSpareId, setEditSpareId] = useState('');

  /** Getting Equipment Types data on load */
  useEffect(() => {
    const obj = {
      pageSize: 100000,
      pageNumber: 1,
    };
    onGetFetchSparesAdminList(obj);
    onGetPihEquipmentTypes();
    onFetchExcelSparesAdminList();
  }, []);

  useEffect(() => {
    setEquipTypeListDrop(sparesEuipType.distintEquipmentTypes);
  }, [sparesEuipType]);

  /** Setting Create new Equipment Model Open */
  const handleCreateEquip = () => {
    setOpenModel(true);
    setEditModelValue(false);
    setEditRecord('');
  };

  /** Setting Properties for upload file  */
  const fileProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      setDisableFileUpload(false);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      setDisableFileUpload(true);
      // }
      return false;
    },
    fileList,
  };

  /** Fucntion to call upload file api and get **presigned Url to upload file to aws s3 bucket */
  const handleUploadFile = async () => {
    let payload = {};
    if (fileList.length > 0) {
      payload.certificate = fileList;
      await onUploadSparesExcel(payload);
    } else {
      notification.warn({ message: 'Please select a file to upload.' });
    }
  };

  /** Removing file and closing upload window on cancel */
  const handleCancelUploadFile = () => {
    setFileList([]);
    setUploading(false);
    setOpenUploadModal(false);
    setDisableFileUpload(false);
  };

  useEffect(() => {
    if (!isSparesListLoading) {
      setFileList([]);
      setUploading(false);
      setOpenUploadModal(false);
      setDisableFileUpload(false);
    }
  }, [isSparesListLoading]);

  const onSearch = (value) => {
    onGetPihEquipmentTypes({ searchKey: value });
  };

  // Conver list of data into Excel sheet
  const handleDownloadExcelSheet = async () => {
    if (isExcelSparesAdminDataLoading) {
      notification.warning({
        message: 'Wait a moment, Spares List is Loading...',
      });
      return;
    }
    const workbook = new ExcelJS.Workbook();
    const sparesListSheet = workbook.addWorksheet('SparesOrderList');

    sparesListSheet.columns = [
      { header: 'Equipment Type', key: 'sparesEquipmentType', width: 20 },
      { header: 'Sub Category', key: 'subCategory', width: 20 }, //Added
      { header: 'Equipment SI No', key: 'equipmentSno', width: 20 },
      { header: 'SAP KIT No', key: 'sapSparesKitNumber', width: 20 },
      { header: 'SAP Number', key: 'partSapNumber', width: 16 },
      { header: 'Description', key: 'description', width: 40 },
      { header: 'Unit', key: 'unit', width: 16 },
      { header: 'Spares Kit Qty', key: 'sparesKitQty', width: 16 }, // Added
      { header: 'Safety Stock', key: 'safetyStock', width: 16 },
      { header: 'Refurb Kit Qty', key: 'refurbKitQty', width: 16 }, // Added
      { header: 'Unit Cost', key: 'unitCost', width: 16 },
      { header: 'Bin Location', key: 'binLocation', width: 20 }, // Added
      { header: 'Supplier Part', key: 'supplierPart', width: 20 }, // Added
      { header: 'Preferred Supplier', key: 'preferredSupplier', width: 30 }, // Added
      { header: 'QTY', key: 'quantity', width: 16 },
      { header: 'Notes', key: 'notes', width: 40 }, // Added
    ];

    const headerRow = sparesListSheet.getRow(1);
    headerRow.height = 40;

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    ExcelSparesAdminList.forEach((row) => {
      sparesListSheet.addRow(row);
    });

    // Write to buffer
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'sparesList.xlsx';
    link.click();
  };

  return (
    <>
      <div className="heat-profile-content-wrapper">
        <div className="heat-profile-card">
          <div className="heat-profile-list-header">
            <div className="heat-profile-header-left">
              <div className="heat-profile-icon-wrap">
                <Package size={22} />
              </div>
              <div className="heat-profile-header-content">
                <div className="heat-profile-title-row">
                  <h3 className="heat-profile-list-title">List of Spares</h3>
                </div>
                <p className="heat-profile-list-description">
                  Manage spares inventory, equipment assignments, and stock levels.
                </p>
              </div>
            </div>

            <div className="heat-profile-header-actions">
              <Button
                type="default"
                icon={<DownloadOutlined />}
                onClick={handleDownloadExcelSheet}
                className="heat-profile-filter-btn"
              >
                Download Database
              </Button>
              <Button
                type="default"
                icon={<ImportOutlined />}
                onClick={() => setOpenUploadModal(true)}
                className="heat-profile-filter-btn"
              >
                Upload
              </Button>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={handleCreateEquip}
                className="heat-profile-add-btn"
              >
                Create New Spare
              </Button>
            </div>
          </div>
          <div style={{ marginTop: '16px' }}>
            <SparesList
              checkOpen={checkOpen}
              setChecksOpen={setChecksOpen}
              sparesAdminList={sparesAdminList}
              isSparesListLoading={isSparesListLoading}
              setCurrency={setCurrency}
              setEditSpareId={setEditSpareId}
              onGetFetchSparesAdminList={onGetFetchSparesAdminList}
              equipTypeList={equipTypeList}
              setEquipTypeList={setEquipTypeList}
              setOpenModel={setOpenModel}
              openModal={openModal}
              spareTypeForm={spareTypeForm}
              equipmentType={equipmentType}
              setEquipmentType={setEquipmentType}
              editModelValue={editModelValue}
              setEditModelValue={setEditModelValue}
              setEditRecord={setEditRecord}
              editRecord={editRecord}
              openPage={openPage}
              setOpenPage={setOpenPage}
            />
          </div>
        </div>
      </div>

      <AddNewSpare
        setOpenModel={setOpenModel}
        openModal={openModal}
        equipTypeListDrop={equipTypeListDrop}
        spareTypeForm={spareTypeForm}
        onAddspare={onAddspare}
        isSparesListLoading={isSparesListLoading}
        currency={currency}
        setCurrency={setCurrency}
        setEditSpareId={setEditSpareId}
        editSpareId={editSpareId}
        editModelValue={editModelValue}
        setEditModelValue={setEditModelValue}
        setEditRecord={setEditRecord}
        editRecord={editRecord}
      />

      <Modal
        width={600}
        className="heatprofile-modal"
        title="Upload Spares Data"
        centered
        open={openUploadModal}
        onCancel={handleCancelUploadFile}
        footer={[
          <Button key="cancel" onClick={handleCancelUploadFile}>
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleUploadFile}
            loading={isSparesListLoading}
          >
            {isSparesListLoading ? 'Uploading...' : 'Upload'}
          </Button>,
        ]}
      >
        <div className="uploadFile_admin" style={{ paddingTop: '10px' }}>
          <Upload
            {...fileProps}
            maxCount={1}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            className="upload-full-width"
            showUploadList={false}
          >
            <div className="premium-upload-trigger">
              <CloudUploadOutlined className="upload-icon" />
              <div className="upload-text">
                <span className="main-text">Click to Select Excel File</span>
                <span className="sub-text">Support for .xls, .xlsx files</span>
              </div>
            </div>
          </Upload>
          {fileList.length > 0 && (
            <div style={{ marginTop: '12px', color: '#4B5563', fontSize: '14px', textAlign: 'center' }}>
              Selected: {fileList[0].name}
            </div>
          )}
          <div style={{ marginTop: '16px', fontSize: '13px', color: '#6b7280', textAlign: 'center' }}>
            Please upload an Excel file (.xlsx or .xls) with spares data
          </div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = ({ spareAdminReducer }) => {
  const sparesAdminList = get(spareAdminReducer, 'sparesAdminList', []);
  const sparesEuipType = get(spareAdminReducer, 'sparesEuipTypeData', []);
  const sparesEuipSn = get(spareAdminReducer, 'sparesEuipSnData', []);
  const sparesSapNo = get(spareAdminReducer, 'sparesSapNoData', []);
  const sparesSapKitNo = get(spareAdminReducer, 'sparesSapKitNoData', []);
  const ExcelSparesAdminList = get(spareAdminReducer, 'ExcelSparesAdminList', []);
  const isSparesListLoading = get(spareAdminReducer, 'isFetchsparesAdminDataLoading', []);
  const isSparesEuipTypeLoading = get(spareAdminReducer, 'isSparesEuipTypeDataLoading', []);
  const isSparesEuipSnLoading = get(spareAdminReducer, 'isSparesEuipSnDataLoading', []);
  const isSparesSapKitNoLoading = get(spareAdminReducer, 'isSparesSapKitNoDataLoading', []);
  const isSparesSapNoLoading = get(spareAdminReducer, 'isSparesSapNoDataLoading', []);
  const isExcelSparesAdminDataLoading = get(spareAdminReducer, 'isExcelSparesAdminDataLoading', []);
  return {
    sparesAdminList,
    sparesEuipType,
    sparesEuipSn,
    sparesSapNo,
    sparesSapKitNo,
    ExcelSparesAdminList,
    isSparesListLoading,
    isSparesEuipTypeLoading,
    isSparesEuipSnLoading,
    isSparesSapKitNoLoading,
    isSparesSapNoLoading,
    isExcelSparesAdminDataLoading,
  };
};

const mapDispatchToProps = {
  onGetFetchSparesAdminList: fetchSparesAdminList,
  onGetPihEquipmentTypes: fetchsparesEuipTypeList,
  onGetSparesEquipmentSn: fetchsparesEuipSNList,
  onGetSparesEquipmentKitNo: fetchSapKitNoList,
  onGetSparesEquipmentSapNo: fetchSapNoList,
  onFetchExcelSparesAdminList: fetchExcelSparesAdminList,
  onAddspare: addAdminSpare,
  onDeleteAdminSpare: deleteAdminSpare,
  onUpdateAdminSpare: updateAdminSpare,
  onUploadSparesExcel: uploadSparesExcel,
};

export default connect(mapStateToProps, mapDispatchToProps)(Spares);
